import React, {useEffect, useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDeleteLeft, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as PetApi from "../../../api/apiPet.js";
import { Timestamp } from "firebase/firestore";
import ReactLoading from 'react-loading';
import { Autocomplete, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const VetHistory = ({medicalHistory, pet, userId, setMedicalHistory, medicines}) => {
    const [openForm, setOpenForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [newMedicalHistory, setNewMedicalHistory] = useState({
        date: "",
        diagnosis: "",
    });
    const [petMedicines, setPetMedicines] = useState([]);
    const [structureMedicalHistory, setStructureMedicalHistory] = useState([]);

    useEffect(() => {
        if (medicalHistory) {
            let medicalHistoryArray = medicalHistory;
            medicalHistoryArray.sort((a, b) => {
                return b.date.seconds - a.date.seconds;
            });
            setStructureMedicalHistory(medicalHistoryArray);
            console.log(medicalHistoryArray);
        }
    }, [medicalHistory]);

    useEffect(() => {
        console.log(medicines);
    }, [medicines]);

    const handleAddMedicalHistory = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const response = await PetApi.addMedicalHistoryToPet(pet.id, newMedicalHistory.date, newMedicalHistory.diagnosis, petMedicines, userId);
        if (response) {
            newMedicalHistory.date =Timestamp.fromDate(new Date(newMedicalHistory.date));
            newMedicalHistory.treatment = petMedicines;
            setMedicalHistory([...medicalHistory, newMedicalHistory]);
            setNewMedicalHistory({
                date: "",
                diagnosis: "",
            });
            setPetMedicines([]);
            setOpenForm(false);
        } else {
            alert("Error al añadir el historial médico");
        }
        setIsLoading(false);
    }



    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <h3>Historial Veterinario</h3>
        {!openForm ? (
          <button
            onClick={() => setOpenForm(true)}
            style={{
              position: "relative",
              backgroundColor: "white",
              borderRadius: 20,
              padding: 10,
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
          >
            <FontAwesomeIcon icon={faPlus} />
            Añadir historial médico
          </button>
        ) : (
          <form
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              padding: 10,
              border: "1px solid #ccc",
              borderRadius: 10,
            }}
          >
            {isLoading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ReactLoading
                  type="spin"
                  color="black"
                  height={50}
                  width={50}
                />
              </div>
            )}
            <div
              style={{
                position: "absolute",
                top: 20,
                right: 10,
              }}
            >
              <button
                style={{
                  backgroundColor: "white",
                  borderRadius: 20,
                  padding: 5,
                  border: "1px solid #ccc",
                  cursor: "pointer",
                  width: 80,
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
                onClick={() => setOpenForm(false)}
              >
                Cerrar
              </button>
            </div>
            <h4>Añadir historial Veterinario</h4>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Fecha"
                maxDate={dayjs(new Date())}
                minDate={dayjs(pet?.birth) || dayjs("2000-01-01")}
                value={
                  newMedicalHistory.date
                    ? dayjs(new Date(newMedicalHistory.date))
                    : null
                }
                onChange={(newValue) => {
                  const dateValue = newValue
                    ? newValue.toDate().toISOString().slice(0, 10)
                    : "";
                  setNewMedicalHistory({
                    ...newMedicalHistory,
                    date: dateValue,
                  });
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <label>Diagnóstico/ Procedimiento</label>
            <TextField
              label="Diagnóstico o procedimiento"
              multiline
              variant="outlined"
              value={newMedicalHistory.diagnosis}
              onChange={(e) =>
                setNewMedicalHistory({
                  ...newMedicalHistory,
                  diagnosis: e.target.value,
                })
              }
              required
            />
            {petMedicines.map((medicine, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: 10,
                  border: "1px solid #ccc",
                  borderRadius: 10,
                  margin: 5,
                }}
              >
                <label>Medicamento</label>
                <Autocomplete
                  freeSolo
                  options={medicines}
                  getOptionLabel={(option) => option.product}
                  renderInput={(params) => (
                    <TextField {...params} label="Medicamento" />
                  )}
                  value={medicine.product ? medicine.product : null}
                  onChange={(e, newValue) => {
                    const updatedMedicines = [...petMedicines];
                    updatedMedicines[index].product = newValue;
                    setPetMedicines(updatedMedicines);
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                      padding: 5,
                      paddingLeft: 0,
                    }}
                  >
                    <TextField
                      label="Dosis"
                      value={medicine.dosis}
                      onChange={(e) => {
                        const updatedMedicines = [...petMedicines];
                        updatedMedicines[index].dosis = e.target.value;
                        setPetMedicines(updatedMedicines);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                      padding: 5,
                      paddingRight: 0,
                    }}
                  >
                    <TextField
                      label="Nº de veces al día"
                      value={medicine.frecuency}
                      onChange={(e) => {
                        const updatedMedicines = [...petMedicines];
                        updatedMedicines[index].frecuency = e.target.value;
                        setPetMedicines(updatedMedicines);
                      }}
                    />
                  </div>
                </div>
                <button
                  style={{
                    backgroundColor: "white",
                    borderRadius: 20,
                    padding: 10,
                    border: "1px solid #ccc",
                    cursor: "pointer",
                    width: 200,
                    alignSelf: "center",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setPetMedicines(petMedicines.filter((_, i) => i !== index));
                  }}
                >
                    <FontAwesomeIcon icon={faTrash} />
                    Eliminar medicamento
                </button>
              </div>
            ))}
            <button
              style={{
                backgroundColor: "white",
                borderRadius: 20,
                padding: 10,
                border: "1px solid #ccc",
                cursor: "pointer",
                width: 200,
                alignSelf: "center",
                margin: 5,
              }}
              onClick={(e) => {
                e.preventDefault();
                setPetMedicines([
                  ...petMedicines,
                  {
                    product: "",
                    dosis: "",
                    frecuency: "",
                  },
                ]);
              }}
            >
                <FontAwesomeIcon icon={faPlus} />
                Añadir medicamento
            </button>
            <button
              style={{
                border: "none",
                backgroundColor: "rgba(232, 222, 201, 0.5)",
                cursor: "pointer",
                width: 100,
                height: 50,
                borderRadius: 20,
                alignSelf: "center",
                margin: 5,
              }}
              type="submit"
              onClick={handleAddMedicalHistory}
            >
              Añadir
            </button>
          </form>
        )}
        {structureMedicalHistory.length !== 0 && (
          <ul>
            {structureMedicalHistory.map((history, index) => (
              <li key={index}>
                <p>Fecha: {history.date.toDate().toLocaleDateString()}</p>
                <p>Diagnóstico: {history.diagnosis}</p>
                <p>Tratamiento:</p>
                <ul>
                  {history.treatment.map((medicine, index) => (
                    <li key={index}>
                      <p>Medicamento: {medicine.product.product}</p>
                      <p>Dosis: {medicine.dosis}</p>
                      <p>Nº de veces al día: {medicine.frecuency}</p>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
};

export default VetHistory;